import { getCommercialPurchaseConfirm, getResearchPurchaseConfirm, } from "../api/generated/wrappers/purchase";
import { getObtainBOM } from "../api/generated/wrappers/obtain";
import { getCommercialPurchaseProduct, getResearchPurchaseProduct, } from "../api/generated/wrappers/purchase";
import { createQueryKeys } from "./create-query-keys";
const purchaseQueryKeys = createQueryKeys("purchase", {
    obtainBOM: (obtainConfirmId) => ({
        queryKey: ["obtain", "bom", obtainConfirmId],
        queryFn: async () => await getObtainBOM(obtainConfirmId),
    }),
    confirm: (isCommercial, params) => ({
        queryKey: ["confirm", isCommercial, params],
        queryFn: async () => isCommercial
            ? await getCommercialPurchaseConfirm(params)
            : await getResearchPurchaseConfirm(params),
    }),
    product: (isCommercial, params) => ({
        queryKey: ["product", isCommercial, params],
        queryFn: async () => isCommercial
            ? await getCommercialPurchaseProduct(params)
            : await getResearchPurchaseProduct(params),
    }),
});
export default purchaseQueryKeys;
